import React, { useState, useMemo } from 'react'
import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption } from '@headlessui/react'

export default function PersonCombobox({ people, value, onChange, placeholder = 'Search person...' }) {
  const [query, setQuery] = useState('')

  const filtered = useMemo(() => {
    if (!query) return people
    return people.filter((p) =>
      p.name.toLowerCase().includes(query.toLowerCase()),
    )
  }, [people, query])

  return (
    <Combobox value={value} onChange={onChange}>
      <div className="relative">
        <ComboboxInput
          className="glass-input w-full"
          displayValue={(person) => person?.name || ''}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={placeholder}
        />
        <ComboboxOptions className="glass-dropdown absolute z-50 mt-2 max-h-60 w-full overflow-auto py-2">
          {filtered.length === 0 ? (
            <div className="px-4 py-3 text-gray-500 dark:text-gray-400 text-sm">No results found.</div>
          ) : (
            filtered.map((person) => (
              <ComboboxOption
                key={person.id}
                value={person}
                className="cursor-pointer select-none px-4 py-2.5 text-gray-900 dark:text-gray-200 data-[focus]:bg-blue-500/20 data-[focus]:text-blue-700 dark:data-[focus]:text-blue-300 transition-colors"
              >
                {person.name}
              </ComboboxOption>
            ))
          )}
        </ComboboxOptions>
      </div>
    </Combobox>
  )
}
